// extracted by mini-css-extract-plugin
export default {"chatBlock":"RiskChat_chatBlock__ejPIY","wrap":"RiskChat_wrap__86UuQ"};